import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'

@Component({
    templateUrl: './AppViews/BugTracker/BugTrackerList.html'
})

export class BugTrackerListComponent implements OnInit {
    public showLoader = false;
    filter: any = { 'DateRangeId': "", 'StatusId': "", 'ProjectId': "", 'StageId': "1", 'TypeId': "", 'CatagoryId': "", 'SeverityId': "", 'PriorityId': "", 'AssigneeId': "" ,'FromDate':"",'ToDate':""};
    issueFilterFlag: any;
    search: any = "";
    userDetail: any;
    getProjectUrl: any;
    constants: Constants;
    issueListItems: any = [];
    projectItems: any = [];
    issueStatusItems: any = [];
    issueStageItems: any = [];
    issuePriorityItems: any = [];
    issueCatagoryItems: any = [];
    issueSeverityItems: any = [];
    issueAssigneeItems: any = [];
    dateRangeItems: any = [];
    isVisible: boolean = true;
    statusFlag:any;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.statusFlag=0;
        //this.filter.StageId = this.constants.enumIssueStage["Open"];
          this.issueFilterFlag=JSON.parse(localStorage.getItem('IssueFilters'));
          if(this.issueFilterFlag!=null && typeof this.issueFilterFlag != 'undefined'){
            this.filter=JSON.parse(localStorage.getItem('IssueFilters'));
            this.search=this.filter.search;
            this.statusFlag=1;
            localStorage.removeItem("IssueFilters")
           
        //  this.getProjectUrl="BugTracker/GetAssignedIssue"    
                                                                               }   

          // this.filter.FromDate=moment().format('DD/MM/YYYY');
        //this.filter.ToDate=moment().format('DD/MM/YYYY');
    }
    ngAfterViewInit() {


    }

    ngOnInit() {

        this.bindFilters();
        this.getIssuedetails();
        
        
    }

    GetStatusForFilter(StageId) {
        
        this.statusFlag=0
        this.GetStatus(StageId);
    }

LoadDate(){
    $('.date').datetimepicker({
        format: 'DD/MM/YYYY'
    });
    
}
GetStatus(StageId){

        if (StageId != "") {

            this._httpService.ajaxPost('BugTracker/GetStatus',
                { "StageId": StageId }).subscribe(
                data => {

                    this.issueStatusItems = data["Statuslist"];

                  
               if(this.statusFlag==0){
                    this.filter.StatusId = "";
                  }
                },
                err => {

                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {

                }

                );
        }
        else {

            this._httpService.ajaxPost('Common/GetParameter',
                { "ParameterTypeId": this.constants.enumParamterTypeName["IssueStatus"] }).subscribe(
                data => {
                    this.issueStatusItems = data["Parameter"];
                    if(this.statusFlag==0){
                    this.filter.StatusId = "";
                  }

                },
                err => {

                });

        }
    }


    bindFilters() {

        this.showLoader = true;
        var userId = 0;
        //   var TeamId = 0;


        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["DateRange"] }).subscribe(
            data => {

                this.dateRangeItems = data["Parameter"];



            },
            err => {
                this.showLoader = false;
            },
            () => {

                this._httpService.ajaxPost('BugTracker/GetAssignedProjectByUserId', { "UserId": this.userDetail.SiteUserId }).subscribe(
                    data => {

                        this.projectItems = data["AssignedProjectList"];

                    },
                    err => {
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = true;
                        this._httpService.ajaxPost('Common/GetParameter',
                            { "ParameterTypeId": this.constants.enumParamterTypeName["IssueSeverity"] }).subscribe(
                            data => {
                                this.issueSeverityItems = data["Parameter"];
                            },
                            err => {
                                this.showLoader = false;
                            },

                            () => {
                                this.showLoader = true;
                                this._httpService.ajaxPost('Common/GetParameter',
                                    { "ParameterTypeId": this.constants.enumParamterTypeName["IssuePriority"] }).subscribe(
                                    data => {
                                        this.issuePriorityItems = data["Parameter"];
                                    },
                                    err => {
                                        this.showLoader = false;
                                    },
                                    () => {
                                        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["IssueStage"] }).subscribe(

                                            data => {

                                                this.issueStageItems = data["Parameter"];
                                            },
                                            err => {
                                                this.showLoader = false;
                                                this._sharedService.ShowMessage(this.constants.globalError);
                                            },
                                            // this._httpService.ajaxPost('Common/GetParameter',
                                            //     { "ParameterTypeId": this.constants.enumParamterTypeName["IssueStatus"] }).subscribe(
                                            //     data => {
                                            //         this.issueStatusItems = data["Parameter"];

                                            //     },
                                            //     err => {
                                            //         this.showLoader = false;
                                            //     },
                                            () => {
                                                        this.showLoader = true;
                                                        this._httpService.ajaxPost('Common/GetParameter',
                                                            { "ParameterTypeId": this.constants.enumParamterTypeName["IssueCategory"] }).subscribe(
                                                            data => {
                                                                this.issueCatagoryItems = data["Parameter"];


                                                            },
                                                            err => {
                                                                this.showLoader = false;
                                                            },
                                                            () => {
                                                                this.showLoader = true;
                                                                this._httpService.ajaxPost('BugTracker/GetUser').subscribe(
                                                                    data => {
                                                                        this.issueAssigneeItems = data["UserList"];


                                                                    },
                                                                    err => {


                                                                        this.showLoader = false;
                                                                    },
                                                                    () => {
                                                                        this.showLoader = false;
                                                                    }

                                                                ); this.showLoader = false;

                                                            }); this.showLoader = false;

                                                    }); this.showLoader = false;

                                            }); this.showLoader = false;

                                    }); this.showLoader = false;

                            }); this.showLoader = false;


                   

            });

        this.GetStatus(this.filter.StageId);
         




        //   setTimeout(function(){
        //             $(".pop-comment").popover({
        //                 //content: 'test'
        //                 content: function() {
        //                     return $(this).parent().find('p').html();
        //                 }
        //             });
        //         }, 500);
    }
    setFilters() {
  
        this.filter = { 'DateRangeId': this.filter.DateRangeId, 'StatusId': this.filter.StatusId, 'ProjectId': this.filter.ProjectId, 'StageId': this.filter.StageId, 'PriorityId': this.filter.PriorityId, 'CatagoryId': this.filter.CatagoryId, 'SeverityId': this.filter.SeverityId, 'AssigneeId': this.filter.AssigneeId, 'Search': this.search ,'FromDate':this.filter.FromDate,'ToDate':this.filter.ToDate};
        localStorage.setItem("IssueFilters",JSON.stringify(this.filter));
    }


    getIssuedetails() {

        var userId = 0;
        userId = this.userDetail.SiteUserId;
        var check= true;
        var tPeriodStartDate = moment(this.filter.FromDate, "DD/MM/YYYY");
        var tPeriodEndDate = moment(this.filter.ToDate, "DD/MM/YYYY");
        if(this.filter.DateRangeId==1){
            if(tPeriodEndDate < tPeriodStartDate )
                {
                        check=false;
                        this._sharedService.ShowMessage("warning|Start Date Should be less than End Date");
                    
                }
        }
         
if(check){
        this.showLoader = true;
        this._httpService.ajaxPost("BugTracker/GetIssueByFilter",
            { 'DateRangeId': this.filter.DateRangeId, 'StatusId': this.filter.StatusId, 'ProjectId': this.filter.ProjectId, 'StageId': this.filter.StageId, 'PriorityId': this.filter.PriorityId, 'CatagoryId': this.filter.CatagoryId, 'SeverityId': this.filter.SeverityId, 'AssigneeId': this.filter.AssigneeId, 'UserId': userId,'FromDate':this.filter.FromDate,'ToDate':this.filter.ToDate }).subscribe(

            data => {

                this.issueListItems = data["IssueList"];
                for (var i = 0; i < this.issueListItems.length; i++) {

                    this.issueListItems[i].RemarkList = this.issueListItems[i].Remark;
                };


                for (var i = 0; i < this.issueListItems.length; i++) {
                    if (this.issueListItems[i].Remark != null && this.issueListItems[i].Remark != "") {
                        this.issueListItems[i].showcomments = true;
                        if (this.issueListItems[i].Remark.split('.').length > 1) {
                            this.issueListItems[i].Remark = this.issueListItems[i].Remark.split('.')[0] + "....";
                        }
                        else {
                            this.issueListItems[i].Remark = this.issueListItems[i].Remark.split('.')[0];
                        }


                    }
                };



            },
            err => {


                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {


                this.showLoader = false;
            }
            );

        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }
     
    }

    showComments(ev, dt) {
        dt.flag = true;
        if (ev.srcElement.className == "showComments" && dt.flag == true) {
            ev.srcElement.id = "shwComments";
            $("#shwComments").tooltip('show');
        }
    }
    removeId(ev) {
        if (ev.srcElement.className == "showComments" && ev.srcElement.id == "shwComments") {
            ev.srcElement.id = "";
        }
    }

    public clearFilter() {
        this.filter = { 'DateRangeId': "", 'StatusId': "", 'ProjectId': "", 'PriorityId': "", 'StageId': "", 'TypeId': "", 'CatagoryId': "", 'UserId': "", 'SeverityId': "", 'AssigneeId': "", 'Search': "" };
        this.getIssuedetails();
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }


}




/** WEBPACK FOOTER **
 ** ./TypeScripts/BugTracker/BugTrackerList.component.ts
 **/